var render = function render(){var _vm=this,_c=_vm._self._c;return _c('adv-button',{staticClass:"addtoCart",attrs:{"disabled":_vm.disabled,"productId":this.productId,"quantity":this.quantity},domProps:{"innerHTML":_vm._s(_vm.buttonText)},on:{"btn-click":_vm.buttonClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }